<template>
  <main id="demo_wrap" class="page-demo">
    <ul>
      <li><button @click="hideToast">Hide Toast</button></li>
      <li><button @click="showToast">Toast</button></li>
      <li><button @click="showLoading">Loading</button></li>
      <li><button @click="showLoadingWithText">Loading with Text</button></li>
      <li><button @click="hideLoading">hide Loading</button></li>
    </ul>
  </main>
</template>

<script>
import toast from "../../common/utils/toast";
import loading from "../../common/utils/loading";

export default {
  name: "demo",

  methods: {
    showToast() {
      toast.show({
        content: 'Hello',
        stayTime: 3000,
        withMask: false
      })
          .then(() => {
            alert('onClose');
          })
    },
    hideToast() {
      toast.hide();
    },
    showLoading() {
      loading.show();
    },
    showLoadingWithText() {
      loading.show({
        content: '加载中'
      });
    },
    hideLoading() {
      loading.hide();
    }
  }

}
</script>

<style scoped>

</style>